// translations/pages/landing/pl.js

export const landingPagePL = {
  "hero": {
    "title": "pAIoneer Labs GmbH",
    "subtitle": "Lokalne rozwiązania AI z naciskiem na ochronę danych",
    "vision": "Następny poziom produktywności: Organisation as a Service. Pracownicy AI przejmują pracę od pomysłu do zweryfikowanego rezultatu.",
    "intro": "Badamy, rozwijamy i integrujemy technologie sztucznej inteligencji, uczenia maszynowego oraz przetwarzania danych. Powstają z tego nasze własne produkty i rozwiązania dopasowane do klienta, które lokalnie analizują, porządkują, anonimizują i chronią dane — a wraz z [Veridion](veridion) także w pełni zautomatyzowani pracownicy AI, którzy wspólnie z ludźmi przejmują całe obszary pracy w firmie.",
    "detail": "Oprogramowanie, które instalujemy u klienta, działa w jego własnej infrastrukturze i nie wymaga połączenia z chmurą. Dokumenty, dane i modele językowe pozostają wewnątrz organizacji."
  },
  "partners": {
    "title": "Partnerzy, którzy nam ufają",
    "subtitle": "Przedsiębiorstwa i instytucje badawcze, w których nasza organizacja AI działa produkcyjnie.",
    "items": {
      "bisigma": {
        "name": "BiSigma",
        "tagline": "BioSignal Measurement and Analysis\nRozwiązania eye-trackingowe i biosygnałowe dla Twoich badań",
        "description": [
          "BiSigma specjalizuje się w systemach do pomiaru i analizy biosygnałów oraz w wysoce precyzyjnych rozwiązaniach eye-trackingowych (śledzenia ruchu gałek ocznych) dla nauki, praktyki klinicznej i badań przemysłowych.",
          "pAIoneer Labs GmbH całkowicie zastąpiła w BiSigma rozwój oprogramowania sztuczną inteligencją, która z powodzeniem tworzy i stale rozwija oprogramowanie do pomiaru oraz analizy biosygnałów."
        ],
        "cta": "Odwiedź BiSigma"
      }
    }
  },
  "products": {
    "title": "Produkty",
    "subtitle": "Sprzedajemy oprogramowanie jako aplikacje desktopowe na stanowiska pracy, jako oprogramowanie serwerowe on-premises lub w chmurze klienta oraz w formie subskrypcji na naszej platformie, na przykład [asystenta tradingowego](finance), którego nasi pracownicy AI sami rozwijają. Ponadto tworzymy systemy AI według wymagań klienta, doradzamy i prowadzimy szkolenia.",
    "partnerLabel": "Produkt partnera",
    "priceOnRequest": "Cena na zapytanie",
    "request": "Wyślij zapytanie",
    "items": {
      "kyveil": {
        "name": "Kyveil Desktop",
        "description": [
          "Kyveil wykrywa i anonimizuje dane osobowe w plikach Word, Excel, OpenDocument, PDF i plikach tekstowych, zanim trafią one do narzędzi AI, testów, analiz lub do osób trzecich. Wykrywanie łączy {presidio}, {spacy} i {flair} i działa w językach niemieckim, angielskim, francuskim, włoskim i hiszpańskim.",
          "Wersja desktopowa działa samodzielnie na standardowych komputerach z systemem Windows, macOS lub Linux, bez GPU i bez zależności od sieci; pliki nie opuszczają stanowiska pracy. Wersja API działa w infrastrukturze klienta, on-premises lub we własnej chmurze klienta, i włącza anonimizację w istniejące systemy i przepływy pracy.",
          "Tryb Replace zastępuje dane osobowe symbolami zastępczymi na potrzeby dokumentacji zgodności, a tryb Fake wiarygodnymi wartościami zastępczymi na potrzeby środowisk testowych; struktura dokumentu zostaje zachowana. Dzięki AnonChat zanonimizowany dokument trafia do ChatGPT, Claude, Gemini lub wewnętrznego modelu językowego dopiero po podglądzie."
        ],
        "cta": "Zobacz Kyveil"
      },
      "veridion": {
        "name": "Veridion Agentic Company Intelligence",
        "claim": "Jeden twórca, nieskończenie wiele rozwiązań.",
        "text": [
          "Firmowa AI pAIoneer Labs GmbH: steruje całym przedsiębiorstwem, jako kompletna organizacja pracowników AI z jednostkami biznesowymi od rozwoju oprogramowania przez elektronikę i obliczenia kwantowe po sprzedaż i administrację, prowadzona przez własną warstwę koordynacyjną.",
          "Ta kadra samodzielnie doprowadza do końca projekty, księgowość, wiedzę firmową, research, rozwój i analizę danych. Jej komunikacja jest zoptymalizowana teorią gier, a gdy potrzebuje zdolności, której jeszcze nie ma, buduje do niej własny system AI.",
          "Działa on-premises, we własnej chmurze lub na naszej platformie. Tam sama rozwija [asystenta tradingowego](finance), a w czacie jest jego AI."
        ],
        "points": [
          "Integruje się z każdym procesem",
          "Uczy się samodzielnie",
          "Brakujące zdolności tworzy sama",
          "Planowalna w stałych cyklach"
        ],
        "cta": "Zobacz Veridion"
      },
      "robuddy": {
        "name": "RoBuddy",
        "description": [
          "RoBuddy to oparty na AI, modułowy system agentów dla firm, który automatyzuje administracyjne zadania biurowe.",
          "Pięć ról obejmuje codzienną pracę: asystent koordynuje terminy, przygotowuje projekty e-maili i wykonuje codzienne zadania. Coach towarzyszy w emocjonalnych i społecznych aspektach życia zawodowego, pomaga w konfliktach i wspiera rozwój osobisty. Pomocnik ds. ochrony danych odpowiada na pytania specjalistyczne dotyczące ochrony danych i prywatności i można go wytrenować w kolejnych dziedzinach, takich jak ochrona przeciwpożarowa czy zgodność z przepisami. Trener szkoleniowy tworzy plany doskonalenia zawodowego, programy wdrożeniowe (onboarding) i moduły szkoleniowe, a doradca analizuje przesłane dokumenty, wspiera podejmowanie decyzji i udziela strategicznych rekomendacji.",
          "RoBuddy jest w 100% hostowany i zarządzany zgodnie z niemieckimi standardami (RODO, BSI-Grundschutz) i można go bezproblemowo podłączyć do Nextcloud lub dowolnego dysku sieciowego.",
          "RoBuddy to agentowy system do pracy biurowej, który można połączyć z Veridion w jedną firmową AI obejmującą całe przedsiębiorstwo: RoBuddy przejmuje zadania na stanowisku pracy, a Veridion podłącza systemy i dane firmy."
        ],
        "cta": "Zobacz RoBuddy",
        "vendorNote": "RoBuddy jest produktem firmy Dr. Hornecker Software-Entwicklung und IT-Dienstleistungen. Dystrybucję prowadzi pAIoneer Labs GmbH."
      }
    }
  },
  "platformNote": {
    "title": "Platforma SaaS",
    "description": "Z tej aplikacji korzystasz w ramach subskrypcji bezpośrednio w przeglądarce, bez instalacji. Działa na naszej własnej platformie, logowanie wymaga drugiego składnika, a wszystkie wywołania AI przechodzą przez jeden centralny punkt dostępu ze stałymi limitami.",
    "apps": {
      "finance": {
        "name": "Asystent tradingowy AI",
        "text": "Podłączasz swój rachunek maklerski, pytasz o swoje pozycje zwykłym językiem i widzisz, które wiadomości wpłynęły na kursy. Dla każdego instrumentu finansowego prognozę oblicza osobny model uczenia maszynowego, trenowany codziennie od nowa, a automat może realizować sygnały. Asystenta rozwijają nasi pracownicy AI; w czacie są też jego AI.",
        "cta": "Zobacz asystenta tradingowego"
      }
    }
  },
  "services": {
    "title": "Kluczowe usługi",
    "veridion": {
      "title": "Pracownicy AI",
      "description": "Całe obszary pracy, obsadzone pracownikami AI, którzy integrują się z procesami i narzędziami przedsiębiorstwa i samodzielnie doprowadzają pracę do końca. Tak pracujemy sami: na tym działa pAIoneer Labs GmbH.",
      "cta": "Zobacz Veridion",
      "features": [
        "Organisation as a Service",
        "Jednostki biznesowe z pracowników AI",
        "Komunikacja zoptymalizowana teorią gier",
        "On-premises lub własna chmura"
      ]
    },
    "custom": {
      "title": "Systemy AI dopasowane do potrzeb klienta",
      "description": "Tworzymy systemy do analizy, przetwarzania, strukturyzacji, anonimizacji i ochrony danych zgodnie z wymaganiami klienta i integrujemy je z lokalną lub należącą do klienta infrastrukturą IT.",
      "features": [
        "Działanie bez chmury",
        "Rozwój produktów",
        "Prototypy",
        "Projekty badawczo-rozwojowe"
      ]
    },
    "dataanalysis": {
      "title": "Analiza danych w rozmowie",
      "description": "Pracownik AI odpowiada na pytania kierowane do podłączonych źródeł danych. Odczytuje katalogi, schematy i kolumny baz danych, przed dostępem do danych przedstawia plan analizy i wyjaśnia niejednoznaczności.",
      "features": [
        "Źródła danych SQL",
        "Korelacja i regresja",
        "Tabele i wykresy",
        "Eksport do PDF i PowerPoint"
      ]
    },
    "memory": {
      "title": "Pamięć firmowa",
      "description": "Pamięć zamiast wyszukiwania dokumentów: fakty, decyzje, zadania i procedury, powiązane z projektami, osobami, systemami i dokumentami, do których należą, wraz z czasem, w którym obowiązują. Rośnie sama z rozmów, spotkań i wyników pracy; nowsza decyzja zastępuje starszą na ten sam temat, nic nie ginie.",
      "features": [
        "Graf wiedzy",
        "Fakty z czasem obowiązywania",
        "Decyzje, nigdy nie utracone",
        "Dostęp według odpowiedzialności"
      ]
    },
    "elektronik": {
      "title": "Elektronika i firmware",
      "description": "Rozwój blisko sprzętu jako usługa: projektowanie układów i symulacja jako cyfrowy bliźniak, firmware aż po sam sensor, ocena podzespołów i alternatyw przed produkcją.",
      "features": [
        "Cyfrowe bliźniaki",
        "Embedded firmware",
        "Analiza kart katalogowych",
        "Ocena podzespołów"
      ]
    },
    "quantum": {
          "title": "Suwerenne LLM i Kwantowe AI",
          "description": "Nasz cel pod nadzorem Veridion: opracować kompaktowe modele językowe Made in Germany, które w przyszłości będą konkurować z wielkimi modelami z USA i Chin, oraz własne Kwantowe Transformery.",
          "cta": "Zobacz Quantum",
          "features": [
                "LLM Made in Germany",
                "Kwantowe Transformery",
                "Własne Quantum IDE",
                "AI rozwija AI"
          ]
    },
    "kyveil": {
      "title": "Lokalna anonimizacja bez GPU",
      "description": "Kyveil anonimizuje dane osobowe lokalnie, jako aplikacja desktopowa na standardowych komputerach z systemem Windows, macOS lub Linux albo jako REST API w infrastrukturze klienta, bez uzależnienia od chmury i bez GPU.",
      "cta": "Zobacz Kyveil",
      "features": [
        "Anonimizacja przed AI",
        "Wykrywanie PII z użyciem NLP",
        "Windows, macOS, Linux",
        "REST API on-premises"
      ]
    },
    "agenticdev": {
      "title": "Intent-Driven Development",
      "description": "Wytwarzanie oprogramowania wspomagane przez AI wymaga wiarygodnego kontekstu. IDD utrwala cele, cele wykluczone, scenariusze, reguły dla agentów i decyzje jako użyteczną pamięć projektu.",
      "cta": "Zobacz IDD",
      "features": [
        "Agentowe wytwarzanie oprogramowania",
        "IDD Vault",
        "Intent/Decisions/Scenarios",
        "Scenariusze jako testy"
      ]
    },
    "finance": {
      "title": "Finanse i analiza rynku",
      "description": "Za asystentem tradingowym stoi własna jednostka biznesowa złożona z cyfrowych pracowników: AI data scientists i eksperci finansowi. Oceniają wiadomości w czasie rzeczywistym, analizują emocje wiadomości finansowych i sami wykonują w czacie obliczenia na danych rynkowych: korelacje, regresje, wykresy i bilans własnych prognoz, każda liczba z wykonanego kroku obliczeniowego. Pod spodem działają prognoza uczenia maszynowego dla każdego instrumentu finansowego oraz automatyczny handel na koncie demo i na żywo.",
      "cta": "Zobacz AI w finansach",
      "features": [
        "AI data scientists i eksperci finansowi",
        "Wiadomości w czasie rzeczywistym, z analizą emocji",
        "Prognoza ML dla każdego instrumentu finansowego",
        "Handel automatyczny"
      ]
    },
    "consulting": {
      "title": "Doradztwo",
      "description": "Doradzamy w kwestiach technicznych, organizacyjnych i strategicznych przy wdrażaniu AI, jej zabezpieczaniu i stosowaniu zgodnie z przepisami.",
      "features": [
        "Ład AI (AI governance)",
        "Zarządzanie danymi",
        "Ochrona danych",
        "Bezpieczeństwo informacji"
      ]
    }
  },
  "contact": {
    "title": "Kontakt",
    "addressLabel": "Adres",
    "phoneLabel": "Telefon",
    "emailLabel": "E-mail",
    "cta": "Napisz wiadomość"
  }
};
